export const EMPTY_COMPANY_LOGO =
	"https://storage.googleapis.com/nebula-static/logos100x100/empty_logo.png";
